module.exports = __webpack_public_path__ + "static/media/no_my_photo.8dc4bff5.png";